import axiosInstance from 'api/axiosInstance';
import { URL_SEARCH_CONTACTS } from 'constants/urls';

/**
 * Search contacts (guards/employees) with pagination.
 *
 * @param {string} [searchKeyword=''] - Search term to filter contacts
 * @param {number} [page=1] - Page number (1-indexed)
 * @param {number} [take=100] - Number of items per page
 * @returns {Promise<{data: Array<{Id: number, FullName: string}>, totalCount: number}>}
 * @throws {Error} If the API request fails
 */
const searchContacts = async (searchKeyword = '', page = 1, take = 100) => {
  const params = new URLSearchParams({
    Id: '0',
    SearchKeyword: searchKeyword,
    Page: page.toString(),
    Take: take.toString(),
  });

  const { data } = await axiosInstance({
    method: 'GET',
    url: `${URL_SEARCH_CONTACTS}?${params}`,
  });

  return {
    data: data.Data || [],
    totalCount: data.TotalResults || 0,
  };
};

export default searchContacts;
